export default __webpack_public_path__ + "static/media/level 3.428f99d9.svg";